import { Banner } from '@/components/ui/banner'
import { Button } from '@/components/ui/button'
import type { PolicyChangeLine } from '@/models/policyChange'
import { cn } from '@/utils/cn'
import { changeLines } from './policyChangeCopy'

/** One change in the request: what it is about, why it was dropped if it was, and in a draft, ways to fix it. */
export function ChangeLineItem({
  line,
  onEdit,
  onRemove,
}: {
  line: PolicyChangeLine
  onEdit?: () => void
  onRemove?: () => void
}) {
  const lines = changeLines(line)
  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-md border px-4 py-3',
        line.dropped ? 'border-(--amber)/40' : 'border-neutral-200'
      )}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 text-sm">
          <div className="font-medium text-neutral-900">{lines.length > 0 ? lines[0] : 'No details yet'}</div>
          {lines.slice(1).map((text) => (
            <div key={text} className="mt-1 text-neutral-600">
              {text}
            </div>
          ))}
        </div>
        {(onEdit || onRemove) && (
          <div className="flex shrink-0 gap-2">
            {onEdit && (
              <Button type="button" variant="outline" size="sm" onClick={onEdit}>
                Edit
              </Button>
            )}
            {onRemove && (
              <Button type="button" variant="outline" size="sm" onClick={onRemove}>
                Remove
              </Button>
            )}
          </div>
        )}
      </div>
      {line.dropped && (
        <Banner variant="warning" small>
          <span className="font-medium">Dropped by your insurance broker:</span> {line.dropReason}
        </Banner>
      )}
    </div>
  )
}
